import last from 'lodash/last';
import intersection from 'lodash/intersection';
import map from 'lodash/map';
import find from 'lodash/find';
import TableColumnsSwitcherStorage from '@Services/AppDBStorage/Storages/TableColumnsSwitcherStorage';
import ReactTableColumnSwitcherHelper from '@Components/Results/services/react-table-columns-switcher-helper.service';
import { TABLE_COLUMNS_SWITCHER_COUNT_OF_COLUMNS_BY_CONTAINER_WIDTH } from '@Components/Results/constants';

export function initHeaders(headers) {
  return headers.map((header) => ({
    ...header,
    cssid: ReactTableColumnSwitcherHelper.getCSSId(header),
    _isChecked: header.isVisible || false,
  }));
}

export function getNonEmptyColumns(headers) {
  return ReactTableColumnSwitcherHelper.getTableColumns(headers, ({ hasContent }) => hasContent);
}

export function getDefaultColumns(headers, defaultColumns) {
  let defaults = ReactTableColumnSwitcherHelper.getTableColumns(headers);
  if (defaultColumns) {
    defaults = defaults.filter(({ id }) => defaultColumns.indexOf(id) !== -1);
  }
  return defaults;
}

export function getDefaultNonEmptyColumns(headers, defaultColumns) {
  return intersection(getNonEmptyColumns(headers), getDefaultColumns(headers, defaultColumns));
}

export function getPossibleToDisplayColumns(headers, defaultColumns, containerWidth) {
  let countColumns;
  let columns;

  TABLE_COLUMNS_SWITCHER_COUNT_OF_COLUMNS_BY_CONTAINER_WIDTH.forEach((config) => {
    if (containerWidth >= config.interval?.[0] && containerWidth <= config.interval?.[1]) {
      columns = getDefaultNonEmptyColumns(headers, defaultColumns);
      countColumns = Math.min(config.count, columns?.length);
    }
  });

  if (columns && countColumns < columns.length) {
    return [...columns.slice(0, countColumns - 1), last(columns)];
  }
  return columns;
}

export function getSavedColumns(headers, tableId) {
  return TableColumnsSwitcherStorage.get(tableId)
    .then((val) => {
      if (!val || !val?.length) {
        return Promise.reject(new Error('No val for tableId'));
      }
      const tableHeaders = ReactTableColumnSwitcherHelper.getTableColumns(headers);
      return map(val, ({ id }) => find(tableHeaders, { id }));
    })
    .catch(Logger?.reject);
}
